export const CONTENT_TYPES = {
  INCOMING_EMAIL: 'incoming_email',
  INPUT_CSAT: 'input_csat',
  INPUT_NPS: 'input_nps',
};
